import Vue from 'vue'

const namespaced = true

const state = {
  rename: {
    file: {},
    visible: false
  },
  move: {
    file: {},
    visible: false
  },
  preview: {
    file: {},
    visible: false
  },
  share: {
    file: {},
    visible: false
  },
  shareKc: {
    file: {},
    visible: false
  }
}

const getters = {
  fileByModal: state => modal => state[modal].file,
  visibleByModal: state => modal => state[modal].visible
}

const actions = {
  setModalFile ({ commit }, { modal, file }) {
    commit('setModalFile', { modal, file })
  },
  hideModal ({ state, commit }, modal) {
    if (state[modal] && state[modal].visible) {
      commit('hideModal', modal)
    }
  },
  hideAllModals ({ state, commit }) {
    const modals = Object.keys(state)
    modals.forEach(modal => {
      if (state[modal] && state[modal].visible) {
        commit('hideModal', modal)
      }
    })
  }
}

const mutations = {
  setModalFile (state, { modal, file }) {
    Vue.set(state[modal], 'file', file)
    Vue.set(state[modal], 'visible', true)
  },
  hideModal (state, modal) {
    Vue.set(state[modal], 'file', {})
    Vue.set(state[modal], 'visible', false)
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
